import type { ReminderAction } from "./types";

export const TOKEN_ERROR_MSG = "הקישור לא תקין או פג תוקף. אנא צרו קשר עם העסק.";
export const SERVER_ERROR_MSG = "משהו השתבש. אנא נסו שוב או צרו קשר עם העסק.";

export const priorActionVerbHebrew = (action: ReminderAction): string => {
  switch (action) {
    case "cancel":
      return "ביטלתם";
    case "reschedule":
      return "הזזתם";
    case "confirm":
      return "אישרתם";
  }
};
